import { render } from "./ListMain.vue?vue&type=template&id=0c062208&scoped=true"
import script from "./ListMain.vue?vue&type=script&lang=js"
export * from "./ListMain.vue?vue&type=script&lang=js"

import "./ListMain.vue?vue&type=style&index=0&id=0c062208&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c062208"],['__file',"src/components/list/ListMain.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c062208"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c062208', __exports__)) {
    console.log('reload')
    api.reload('0c062208', __exports__)
  }
  
  module.hot.accept("./ListMain.vue?vue&type=template&id=0c062208&scoped=true", () => {
    console.log('re-render')
    api.rerender('0c062208', render)
  })

}


export default __exports__